import styled from 'styled-components';
import Image from '@stencil/image';
import {headingSizes, textSizes} from '@stencil/build-theme';
import Button from '../../../../core-components/Button/Button';

export const SoldOutWrapper = styled.div<{isVideo?: boolean}>(
  props => `
    flex: 1;
    width: 50%;
    border: 1px solid #E5EDF6;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow:${props.isVideo ? 'hidden' : ''};
  `,
);

export const SoldOutDescWrapper = styled.div(
  props => `
  text-align: right;
  background: linear-gradient(180deg, ${props.theme.colors.goRed.light} 35%, ${props.theme.colors.goWhite.base} 109.74%);
  padding: 16px;
  border-radius: 8px;
  text-align: left;
`,
);

export const ImageWrapper = styled(Image)`
  width: 150px;
  margin-bottom: 2rem;
`;

export const SoldOutHeaderText = styled.p(
  props => `
  font-weight: 600;
  font-size: 20px;
  color: ${props.theme.colors.goRed.base};
  padding-bottom: 8px;
  padding-top: 12px;
`,
);

export const SoldOutDescText = styled.p(
  props => `
  font-size: 14px;
  color: ${props.theme.colors.downriver.base};
  margin-bottom: 2rem;
`,
);

export const ButtonWrapper = styled(Button)`
  width: 100%;
  margin: 0;
  font-size: ${props => props.theme.font.custom(16)};
`;

export const PropertyAvailableText = styled.p`
  ${textSizes.MediumW3}
  color: ${props => props.theme.colors.downriver.base};
  padding: 4px 12px 12px 0;
`;

export const AvailableDateList = styled.ul(
  props => `
  display: flex;
  flex-wrap: no-wrap;
  overflow: auto;
  padding: 0 12px 12px 0;
  /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
       display: none;
    }

   /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
`,
);

export const AvailableDateListItem = styled.li(
  props => `
  flex-shrink: 0;
  margin-right: 8px;
  border: ${props.isDisabled ? 'none' : `1px solid ${props.theme.colors.shadow.base}`};
  ${props.isDisabled ? `background-color: ${props.theme.colors.ash.light};` : ''}
  border-radius: 8px;
  text-align:center;
  padding: 8px;
  :last-child {
    margin-right: 0;
  }
  cursor:pointer;
`,
);

export const DateRangeText = styled.p`
  ${textSizes.BaseW1}
  color: ${props => (props.isDisabled ? 'rgba(0, 0, 0, 0.5)' : props.theme.colors.black.dark)};
  margin-bottom: 4px;
`;

export const RoomLeftText = styled.p(
  props => `
  color: ${props.theme.colors.goGreen.base};
  font-weight: 400;
  font-size: 12px;
  padding: 8px 0;
`,
);

export const RoomPriceText = styled.p`
  ${textSizes.BaseW1}
  text-align: center;
  color: ${props =>
    props.isDisabled ? 'rgba(0, 0, 0, 0.5)' : props.theme.colors.downriver.medium};
`;

export const AltDatesCta = styled.a`
  ${textSizes.BaseW3}
  display: inline-block;
  color: #2276e3;
  text-align: right;
  padding: 0 12px 12px 0;
`;

export const AlternateDateCardLoading = styled.li(
  props => `
    font-size:${props.theme.font.custom(12)};
    padding: 10px;
    flex-shrink: 0;
    border: 1px solid ${props.theme.colors.ash.dark};
    border-radius: 4px;
    margin-right: 6px;
    text-align: center;
    `,
);
